// extracted by mini-css-extract-plugin
module.exports = {"item":"OrcamentoItem_item__2c7CJ","data":"OrcamentoItem_data__2MIvv","subtitle":"OrcamentoItem_subtitle__3LTka","custo":"OrcamentoItem_custo__27kz4"};